import React, { PropTypes } from "react";
import Bildtext from 'components/Helpers/Bildtext/Bildtext';

class Iframe extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      height: false
    };
    this.onLoad = this.onLoad.bind(this);
    this.resize = this.resize.bind(this);
  }

  onLoad() {
    if (this.props.value && this.props.value.height && this.props.value.height === "auto") {
      this.resize();
      this.interval = setInterval(this.resize, 300);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  resize() {
    const height = this.iframe.contentDocument && this.iframe.contentDocument.body.clientHeight;
    if (height) {
      this.setState({
        height: height + 'px'
      })
    }
  }

  render() {
    const { value, children } = this.props;
    const src = (typeof value === 'string' && value) || (value && value.src);
    const id = (typeof value === 'string' && value) || (value && value.id);
    const size = require('styleTools/SizeClasses.scss');
    const sizeClass = (value && value.storlek && size[value.storlek]) || size.l;
    let height = this.state.height || (value && value.height != "auto" && value.height) || "56.25%";
    return (
      <div className={sizeClass}>
        <div className="resizer" id={id} style={{position:"relative", display:"block", paddingTop: height}}>
          <iframe
            style={{position:"absolute", top:"0", width: "100%", height:"100%"}}
            src={src}
            scrolling="no"
            allowFullScreen="true"
            data-allowvr="yes"
            ref={(iframe) => { this.iframe = iframe; }}
            onLoad={this.onLoad}
          />
        </div>
        {children}
        {typeof value === 'object' &&
        <Bildtext text={value.bildtext} foto={value.foto} credit={value.credit}/>
        }
      </div>
    );
  }
}


export default Iframe;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Iframe/Iframe.js
 **/